/**
 * Normalize and sanitize a URL string for safe usage in link controls.
 *
 * - Trims whitespace
 * - Allows http(s), mailto, tel, /, and #
 * - Adds https:// when no scheme is provided
 * - Returns empty string for invalid or disallowed URLs
 */
export function sanitizeAndNormalizeUrl(rawUrl: string): string {
  const trimmed = (rawUrl ?? '').trim();
  if (!trimmed) return '';

  if (trimmed.startsWith('//')) return '';

  if (trimmed[0] === '#' || trimmed[0] === '/') {
    return trimmed;
  }

  const schemeMatch = trimmed.match(/^([a-z][a-z0-9+.-]*):/i);

  if (schemeMatch) {
    const scheme = schemeMatch[1].toLowerCase();

    if (scheme === 'http' || scheme === 'https') {
      try {
        new URL(trimmed);
        return trimmed;
      } catch {
        return '';
      }
    }

    if (scheme === 'mailto' || scheme === 'tel') {
      if (scheme === 'mailto') {
        const mailtoMatch = /^mailto:([^?]+)(\?.*)?$/i.exec(trimmed);
        if (!mailtoMatch) return '';
        const address = mailtoMatch[1];
        if (!/^[^@\s,]+@[^@\s,]+\.[^@\s,]+(,[^@\s,]+@[^@\s,]+\.[^@\s,]+)*$/i.test(address)) {
          return '';
        }
      }

      if (scheme === 'tel') {
        if (!/^tel:\+?[0-9()\-\s.]{3,}$/i.test(trimmed)) return '';
      }

      try {
        new URL(trimmed);
        return trimmed;
      } catch {
        return '';
      }
    }

    return '';
  }

  try {
    return new URL(`https://${trimmed}`).toString();
  } catch {
    return '';
  }
}
